import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import CheckCircleOutlineIcon from "@atlaskit/icon/glyph/check-circle-outline";
import ErrorIcon from "@atlaskit/icon/glyph/error";
import { token } from "@atlaskit/tokens";

import { fontSize } from "@/components/signup/utils";
import { wacToken } from "@/libraries/design/foundations";

export const InputIcon = ({ valid }: { valid: boolean | undefined }) => {
    const { formatMessage } = useIntl();

    const validMessage = formatMessage({
        id: "signupForm.accountCreation.validEmailIcon",
        defaultMessage: "Success"
    });

    const invalidMessage = formatMessage({
        id: "signupForm.accountCreation.invalidEmailIcon",
        defaultMessage: "Warning"
    });

    if (valid === undefined) {
        return null;
    }

    return valid ? (
        <div css={iconValidCss}>
            <CheckCircleOutlineIcon label={validMessage} size="medium" />
        </div>
    ) : (
        <div css={iconInvalidCss}>
            <ErrorIcon label={invalidMessage} size="medium" />
        </div>
    );
};

const iconWrapperStyle = {
    alignItems: "center",
    display: "flex",
    fill: wacToken("color.neutral.light0"),
    fontSize: fontSize.md,
    paddingInlineEnd: 8
};

const iconValidCss = css({
    ...iconWrapperStyle,
    color: token("color.border.success")
});

const iconInvalidCss = css({
    ...iconWrapperStyle,
    color: token("color.border.danger")
});
